import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-577bef07"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-select"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "select-header-text"
}, "筛选")], -1));
const _hoisted_3 = {
  class: "select-list"
};
const _hoisted_4 = {
  class: "select-list-item-title"
};
const _hoisted_5 = {
  key: 0,
  class: "select-list-item-content"
};
const _hoisted_6 = {
  key: 1,
  class: "select-list-item-content"
};
const _hoisted_7 = {
  key: 2,
  class: "select-list-item-content"
};
const _hoisted_8 = ["onUpdate:modelValue", "name", "onClick"];
const _hoisted_9 = ["onUpdate:modelValue", "name", "onClick"];
const _hoisted_10 = {
  key: 3
};
const _hoisted_11 = {
  class: "select-bottom flex-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_ScreeningDropdown = _resolveComponent("ScreeningDropdown");
  const _component_van_field = _resolveComponent("van-field");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "c-a0ttpa",
    style: _normalizeStyle({
      height: $data.contentHeight
    })
  }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.searchItems, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "select-list-item",
      key: item.name
    }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), item.type == 'flatSelect' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_row, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, item2 => {
        return _openBlock(), _createBlock(_component_van_col, {
          span: "7",
          class: _normalizeClass(["select-list-item-content-item", $options.isSelected(item.name, item2.key) ? 'select-active' : '']),
          key: item2.key,
          onClick: $event => $options.handleClick(item.name, item2.key, item.mutiSelect)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item2.value), 1)]),
          _: 2
        }, 1032, ["class", "onClick"]);
      }), 128))]),
      _: 2
    }, 1024)])) : item.type == 'dropdown' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_ScreeningDropdown, {
      ref_for: true,
      ref: 'dropdown' + item.name,
      name: item.name,
      request: item.request,
      keyName: item.keyName,
      valueName: item.valueName,
      paramName: item.paramName,
      title: item.title,
      onSelectDropdownItem: $options.handleDropdownSelect,
      onClearDropdownItem: $options.handleDropdownClear
    }, null, 8, ["name", "request", "keyName", "valueName", "paramName", "title", "onSelectDropdownItem", "onClearDropdownItem"])])) : item.type == 'datePicker' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_van_row, null, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "10"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => item.selectedOptions[0] = $event,
          name: item.name + 'From',
          class: "select-list-item-content-input",
          readonly: "",
          onClick: $event => $options.handleDateClick(item.name, 0)
        }, null, 8, _hoisted_8), [[_vModelText, item.selectedOptions[0]]])]),
        _: 2
      }, 1024), _createVNode(_component_van_col, {
        span: "4"
      }, {
        default: _withCtx(() => [_createTextVNode(" 至 ")]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "10"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => item.selectedOptions[1] = $event,
          name: item.name + 'To',
          class: "select-list-item-content-input",
          readonly: "",
          onClick: $event => $options.handleDateClick(item.name, 1)
        }, null, 8, _hoisted_9), [[_vModelText, item.selectedOptions[1]]])]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024)])) : item.type == 'input' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_field, {
      modelValue: item.selectedOptions[0],
      "onUpdate:modelValue": $event => item.selectedOptions[0] = $event,
      placeholder: "请输入"
    }, null, 8, ["modelValue", "onUpdate:modelValue"])])) : _createCommentVNode("", true)]);
  }), 128))])], 4), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "select-bottom-item",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleReset && $options.handleReset(...args))
  }, "重置"), _createElementVNode("div", {
    class: "select-bottom-item",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleConfirm && $options.handleConfirm(...args))
  }, "确认")]), _createVNode(_component_PopupDatePickerCpt, {
    ref: "popupDatePickerCpt",
    onOnSelectedChange: $options.onDatePickerSelectedChange
  }, null, 8, ["onOnSelectedChange"])]);
}